import React, { useState, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/qavaApp.css';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Switch } from 'react-router';
//import { IonReactRouter } from '@ionic/react-router';
//import { BrowserRouter } from "react-router-dom";

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

// import { Tab_Management_Inventory } from '../components/Tab_Management_Inventory';
// import { Tab_Management_Employee } from '../../../zInternal_Features/merchant/components/Tab_Management_Employee';
// import { App_Header } from '../components/App_Header';
// import { Tab_Management_Jobs } from '../../../zInternal_Features/merchant/components/Tab_Management_Jobs';

export function User_Management (props) {

    let authClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID] = useState(authClient_context.acctID);
    const [schema, setSchemaName] = useState(authClient_context.schema);
    const [employeeID, setEmployeeID] = useState(authClient_context.employeeID);

//export const AccountSetting: React.FC<accountSettingProps> = (props: any) => {

    //let [acctID, setAcctID] = useState(props.accountID);
    //let [schema, setSchema] = useState(props.schemaName);
    //let [showInvoiceTemplates, setShowInvoiceTemplates] = useState(false);
    //let [showFormTemplates, setShowFormTemplates] = useState(false);



    //alert('In Management ');
    //alert(acctID);
    //alert(authClient_context.accessRights[0]);
    //alert(authClient_context.device);
    //alert(schema);

    return (
            <React.Fragment>
            <IonModal isOpen={true}>

            <IonHeader className='appModalHeader'>
                        <h3> Management </h3>
            </IonHeader>

            <IonContent className='appGridContent'>
                    <IonTabs >

                    {/*<IonRouterOutlet>
                        <Route path='/hotel_management/inventoryTab' exact={true} render={() => <Tab_Management_Inventory  accountID={ acctID } employeeID={ employeeID } schemaName={ schema } />} />
                        <Route path='/hotel_management/employeeTab' exact={true} render={() => <Tab_Management_Employee  />} />
                        <Route path='/hotel_management/jobsTab' exact={true} render={() => <Tab_Management_Jobs  />} />

    </IonRouterOutlet>*/}

                    <IonTabBar slot='top'>
                        <IonTabButton id='inventoryTab' tab='inventoryTab' href='/hotel_management/inventoryTab'>
                            <IonLabel>Inventory</IonLabel>
                    </IonTabButton>
                    {(authClient_context.accessRights[0] == 'admin' && JSON.parse(authClient_context.feature).employeeHR == 'ACTIVE') && <IonTabButton id='employeeTab' tab='employeeTab' href='/hotel_management/employeeTab'>
                            <IonLabel>Employee</IonLabel>
                        </IonTabButton>}
                    {(authClient_context.accessRights[0] == 'admin' && JSON.parse(authClient_context.feature).jobs == 'ACTIVE') && <IonTabButton id='jobsTab' tab='jobsTab' href='/hotel_management/jobsTab'>
                            <IonLabel>Jobs</IonLabel>
                        </IonTabButton>}
                    </IonTabBar>

                </IonTabs>
            </IonContent >

            <IonFooter className='appFooter_internal'>
                <IonGrid>
                    <IonRow >
                        <IonCol size='6'>
                            <IonButton onClick={() => props.closeModal()}>Close</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
            </IonModal>

        </React.Fragment>
    );
};


export default User_Management;